import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { SpecialProgrammesFilterOptionValue } from '@studyportals/search-filters/server-side';

class MastersSpecialProgrammesFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.SPECIAL_PROGRAMMES,
			[
				new FilterOptionInformation('Executive Programmes', SpecialProgrammesFilterOptionValue.EXECUTIVE_PROGRAMMES, 'executive-programmes', 'Executive Programmes'),
				new FilterOptionInformation('Joint Programmes', SpecialProgrammesFilterOptionValue.JOINT_PROGRAMMES, 'joint-programmes', 'Joint Programmes'),
				new FilterOptionInformation(
					'Erasmus Mundus Joint Masters',
					SpecialProgrammesFilterOptionValue.ERASMUS_MUNDUS,
					'erasmus-mundus',
					'Erasmus Mundus Joint Masters',
				),
			],
			[SpecialProgrammesFilterOptionValue.JOINT_PROGRAMMES, SpecialProgrammesFilterOptionValue.ERASMUS_MUNDUS, SpecialProgrammesFilterOptionValue.EXECUTIVE_PROGRAMMES],
		);
	}
}

export default new MastersSpecialProgrammesFilterDefinition();
